import {TFunction} from "i18next";
import * as yup from "yup";
import {StageIdentifier} from "../../../app/api/model/stage";
import {NO_SELECTION} from "../../../components/input/StageSelect";
import dayjs from "dayjs";
import {DeviceJobField} from "../../../app/api/model/device";

export const getDeviceStagesValidationSchema = (t: TFunction) =>
    yup
        .object({
            primaryStage: yup.string().nullable(),
            stages: yup.array().of(yup.string()),
        })
        .test({
            name: "stageValidationError",
            message: t("validation_primaryStageMustBeSelected"),
            test: function (values) {
                return values.primaryStage && values.primaryStage !== NO_SELECTION
                    ? !!(values?.stages?.length && values.stages.indexOf(values.primaryStage) >= 0)
                    : true;
            },
            exclusive: false,
        })
        .test({
            name: "stageValidationErrorMutuallyExclusive",
            message: t("validation_mutuallyExclusiveStages"),
            test: function (values) {
                return values?.stages?.find((s) => s === StageIdentifier.LEGACY) ? values.stages?.length === 1 : true;
            },
            exclusive: false,
        });

const MAX_PAST_DAYS = 90;
const getMaxPastDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - MAX_PAST_DAYS);
    return date;
};

export const getDeviceMassStorageValidationSchema = (t: TFunction) =>
    yup.object({
        stage: yup.string().required(t("validation_inputRequired")),
        periodStart: yup
            .date()
            .nullable()
            .required(t("validation_inputRequired"))
            .min(getMaxPastDate(), t("errorBody_rdlDateRange"))
            .test("isValidMax", t("errorBody_rdlDateRange"), function (value) {
                return !value || dayjs(value).isBefore(dayjs().add(1, "day"));
            })
            .test("isBeforePeriodEnd", t("errorBody_startDateAfterEndDate"), function (value) {
                const periodEnd = this.parent[DeviceJobField.PERIOD_END];
                return !value || dayjs(value).isBefore(dayjs(periodEnd).add(1, "day"));
            }),
        periodEnd: yup
            .date()
            .nullable()
            .required(t("validation_inputRequired"))
            .min(getMaxPastDate(), t("errorBody_rdlDateRange"))
            .test("isValidMax", t("errorBody_rdlDateRange"), function (value) {
                return !value || dayjs(value).isBefore(dayjs().add(1, "day"));
            })
            .test("isAfterPeriodStart", t("errorBody_endDateBeforeStartDate"), function (value) {
                const periodStart = this.parent[DeviceJobField.PERIOD_START];
                return !value || dayjs(value).isAfter(dayjs(periodStart).subtract(1, "day"));
            }),
    });
